/* global google */
import React, {Component} from 'react';
import styled from 'styled-components';
import media from '../MediaQueries.js';
import FontAwesome from 'react-fontawesome';
import PropTypes from 'prop-types';
import { Collapse, Input, InputGroup, InputGroupButton, FormFeedback, Navbar, NavbarToggler, NavbarBrand, Nav, NavItem,
        NavLink, Container, Row, Col, Jumbotron, Button, ButtonGroup, Dropdown, DropdownToggle } from 'reactstrap';
import { Link } from 'react-router-dom';

export default class ShippingHandlingContent extends Component {
  static propTypes = {
    toggleOrders: PropTypes.func.isRequired,
    ordersOpen: PropTypes.bool.isRequired,
    toggleShipping: PropTypes.func.isRequired,
    shippingOpen: PropTypes.bool.isRequired,
    toggleReturns: PropTypes.func.isRequired,
    returnsOpen: PropTypes.bool.isRequired,
    toggleBreakage: PropTypes.func.isRequired,
    breakageOpen: PropTypes.bool.isRequired,
  }

  constructor(props) {
    super(props);
  }

  render() {

    return (
    	<Container_s>
        <Container_1000>

            <h2>Shipping & Handling</h2>
            <h3>Find information regarding our shipping & handling policies</h3>
            <hr />

            <ItemDropdownContainer containerOpen={this.props.ordersOpen} onClick={() => this.props.toggleOrders()} >
            <Dropdown toggle={() => ''} >
              <DropdownToggle caret>
                 <h2>Orders</h2>
              </DropdownToggle>
            </Dropdown>
            <Collapse isOpen={this.props.ordersOpen}>
              <p>
                 All of our orders are considered <b>RUSH</b> orders and are shipped <b>ABSOLUTELY</b> as soon as possible.
                 Please understand that exceptions will occur. Therefore, please plan ahead on larger orders, and
                 especially during the holiday season.
              </p>
            </Collapse>
            </ItemDropdownContainer>

            <ItemDropdownContainer containerOpen={this.props.shippingOpen} onClick={() => this.props.toggleShipping()} >
            <Dropdown toggle={() => ''} >
              <DropdownToggle caret>
                 <h2>Shipping</h2>
              </DropdownToggle>
            </Dropdown>
            <Collapse isOpen={this.props.shippingOpen}>
              <p>
                 Standard shipping is via USPS, UPS, or FedEx within the 48 contiguous states unless otherwise specified.
                 Candles are heavy items to ship - all orders are subject to actual shipping charges only, and are F.O.B. Galeton, PA. Please 
                 provide your name, a street or route address (we cannot accept a P.O. box numbers for UPS shipments), zip code and telephone number
                 with area code, and any special instructions required for accurate delivery. For expedited, or any other non-standard shipping, or to
                 locations outside of the continental United States, additional charges may apply. FedEx and UPS include up to $100 of insurance in the
                 shipping charge. Additional shipping insurance is available. Contact us if you would like to insure your order. On undeliverable and
                 refused packages, a 20% restocking fee and the charges to ship the package and the charges to return to Heart's Desire will be
                 charged to you.
              </p>
            </Collapse>
            </ItemDropdownContainer>

            <ItemDropdownContainer containerOpen={this.props.returnsOpen} onClick={() => this.props.toggleReturns()} >
            <Dropdown toggle={() => ''} >
              <DropdownToggle caret>
                 <h2>Returns</h2>
              </DropdownToggle>
            </Dropdown>
            <Collapse isOpen={this.props.returnsOpen}>
              <p>
                 All returns must be made within 10 business days of receipt of goods.
                 Sorry, we can only issue merchandise replacements or credit to future orders. No cash refunds.
                 No refunds on shipping and handling. Items must be in new, resellable condition with credit given
                 after inspection. Returns are subject to a 20% restocking fee and the customer is responsible for the
                 return freight. Please call in advance before returning merchandise.
              </p>
            </Collapse>
            </ItemDropdownContainer>

            <ItemDropdownContainer containerOpen={this.props.breakageOpen} onClick={() => this.props.toggleBreakage()} >
            <Dropdown toggle={() => ''} >
              <DropdownToggle caret>
                 <h2>Breakage</h2>
              </DropdownToggle>
            </Dropdown>
            <Collapse isOpen={this.props.breakageOpen}>
              <p>
                 We pack your orders with great care. However, please inspect your order as soon as you receive items
                 and report any damages immediately to the freight company. Save the carton and damaged items for inspection.
                 Please notify us within 5 days of receiving a product that is damaged. After 15 days, no claims will be accepted.
              </p>
            </Collapse>
            </ItemDropdownContainer>

            <hr />
        </Container_1000>
      </Container_s>
		);
	}
}

const Container_s = styled(Container)`
  padding: 0!important;
  padding-top: 10px!important;
`;

const Container_1000 = styled(Container)`
  max-width: 1000px;
  margin: 0 auto;
  padding: 0!important;

  h2,h3 {
    color: #76451F;
    font-size: 36px;
    font-weight: bold;
    text-align: center;
    margin: 10px 15px 10px 15px;
  }
  h3 {
    color: black;
    font-size: 15px;
    ${media.lg` font-size: 17px; `}
    ${media.xl` font-size: 19px; `}
    margin-bottom: 20px;

  }
  hr {
    border-top: 1.1px solid #8A572A;
  }
`;


const ItemDropdownContainer = styled(({ containerOpen, ...rest }) => <Container {...rest} />)`
  margin-bottom: 10px;
  text-align: left;
  background-color: ${a => a.containerOpen ? "#BCA368" : "#c9b483"};
  cursor: pointer;

  .dropdown {
    background-color: ${a => a.containerOpen ? "#BCA368" : "#c9b483"};
    height: 100px;
    line-height: 100px;

    button {
      width: 100%;
      padding: 0;
      font-family: 'Handlee';
      background: none;
      border: none;
      vertical-align: middle;
      word-break: break-all;
      white-space: normal;
      cursor: pointer;

      h2 {
        margin: 0;
        font-size: 20px;
        ${media.lg` font-size: 22px; `}
        text-align: left;
        
        color: #76451F;
        font-weight: bold;
      }

      ::after {
        float: right;
        margin-top: -9px;
          border-top-width: ${a => a.containerOpen ? 0 : ""};
          border-bottom: ${a => a.containerOpen ? "4.8px solid #000000" : ""};
      }

      :focus {
        box-shadow: none;
      }
    }
  }
  .collapse, .collapsing {
    background-color: ${a => a.containerOpen ? "#BCA368" : "#c9b483"};

    p {
      margin-bottom: 0px;
      font-size: 14px;
      ${media.lg` font-size: 16px; `}
      ${media.xl` font-size: 18px; `}
      font-family: 'Raleway';
    }
  }
`;


// WEBPACK FOOTER //
// ./src/components/ShippingHandlingContent.js